module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Angle-double-left-5056745ce1aaf5e673e3008d9b8ce337.svg";